import React, { useEffect, useState } from "react";
import images from "../../../utilities/images/images";
import axios from "axios";
import { url_260 } from "../../../custom_utilities/api_services";
import { useHistory } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import DateRangePicker from "./ReferAndEarnModals/DateRangePicker";
import { connect } from "react-redux";
import uiActions from "../../../redux/ui/action";
import { Button, Modal } from "react-bootstrap";
import { withRupeeSymbol } from "../../../custom_utilities/custom_useful_functions";
import "./Streak.scss";
import { toastifyMessage } from "../../../custom_utilities/toastify_config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header_component from "../structure_components/desktop_screens/header_component/header_component";
import StreakPaymentDueModal from "./streak-model/StreakPaymentDueModal";
import moment from "moment";

const Streak = (props) => {
  const { tokenType, token, startLoading, finishLoading } = props;
  const history = useHistory();

  const [state, setState] = useState({
    streaksData: {},
    encUpi: "",
    encBank: {
      acc_name: "",
      ifsc_code: "",
      acc_no: "",
      cacc_no: "",
    },
  });

  const [openAccordion, setOpenAccordion] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dayWiseStreakData, setDayWiseStreakData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
  const [showRedeemConfirmModal, setShowRedeemConfirmModal] = useState(false);
  const [showRedemptionSuccessModal, setShowRedemptionSuccessModal] =
    useState(false);
  const [showFinalSuccessModal, setShowFinalSuccessModal] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [paymentDueModal, setShowPaymentDueModal] = useState(false);
  const [paymentDueModal1, setShowPaymentDueModal1] = useState(false);
  const [accountNumberError, setAccountNumberError] = useState("");
  const [showAdjustmentSuccess, setShowAdjustmentSuccess] = useState(false);
  const [liveClassData, setLiveClassData] = useState([]);
  const [liveClassLoading, setLiveClassLoading] = useState(false);
  const [upiError, setUpiError] = useState("");

  const formatStreakDateForApi = (dateStr) => {
    const formats = [
      "DD/MMM/YYYY",
      "DD MMM, YYYY",
      "DD MMM YYYY",
      "YYYY-MM-DD",
    ];
    for (const fmt of formats) {
      const parsed = moment(dateStr, fmt, true);
      if (parsed.isValid()) {
        return parsed.format("YYYY-MM-DD");
      }
    }
    const loose = moment(dateStr);
    return loose.isValid() ? loose.format("YYYY-MM-DD") : null;
  };

  useEffect(() => {
    streaksApi();
    getDayWiseStreak();
  }, [tokenType, token, paymentDueModal1]);

  useEffect(() => {
    if (state.streaksData?.payment_account_info) {
      setState((prevState) => ({
        ...prevState,
        encUpi:
          prevState.encUpi ||
          state.streaksData.payment_account_info.enc_upi?.upi_id ||
          "",
        encBank: {
          acc_name:
            state.streaksData.payment_account_info.enc_bank?.acc_name ||
            prevState.encBank.acc_name,
          ifsc_code:
            state.streaksData.payment_account_info.enc_bank?.ifsc_code ||
            prevState.encBank.ifsc_code,
          acc_no:
            state.streaksData.payment_account_info.enc_bank?.acc_no ||
            prevState.encBank.acc_no,
          cacc_no:
            state.streaksData.payment_account_info.enc_bank?.cacc_no ||
            prevState.encBank.cacc_no,
        },
      }));
    }
  }, [state.streaksData]);

  useEffect(() => {
    if (
      state.encBank.acc_no &&
      state.encBank.cacc_no &&
      state.encBank.acc_no !== state.encBank.cacc_no
    ) {
      setAccountNumberError("Account numbers do not match");
    } else {
      setAccountNumberError("");
    }
  }, [state.encBank.acc_no, state.encBank.cacc_no]);

  const streaksApi = async () => {
    try {
      const response = await axios.get(`${url_260}?checkDues=1`);

      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          streaksData: response.data.data,
        }));
        setShowPaymentDueModal(
          Number(response.data.data.checkDues.show_pop_up)
        );
      }
    } catch (error) {
      toastifyMessage({ status: 500, message: "Failed to fetch streak data" });
    }
  };

  const getDayWiseStreak = async (fromDate, toDate) => {
    startLoading();
    const headers = { Authorization: `${tokenType} ${token}` };
    let apiUrl =
      "https://learning.motion.ac.in/motioneducation/api/v1/getDayWiseStreak";

    if (fromDate && toDate) {
      apiUrl += `?from_date=${fromDate}&to_date=${toDate}`;
    }

    try {
      const response = await axios.get(apiUrl, { headers });
      if (response.data.status === 200) {
        setDayWiseStreakData(response.data.data || []);
        if (
          response.data.fromDate &&
          response.data.toDate &&
          !fromDate &&
          !toDate
        ) {
          setStartDate(response.data.fromDate);
          setEndDate(response.data.toDate);
        }
      }
    } catch (error) {
      toastifyMessage({
        status: 500,
        message: "Failed to fetch day-wise streak data",
      });
    } finally {
      finishLoading();
    }
  };

  const toggleAccordion = (index) => {
    const newIndex = openAccordion === index ? null : index;
    setOpenAccordion(newIndex);

    if (newIndex !== null && dayWiseStreakData[newIndex]) {
      const formattedDate = formatStreakDateForApi(
        dayWiseStreakData[newIndex].date
      );
      if (!formattedDate) {
        toastifyMessage({ status: 400, message: "Invalid date format" });
        return;
      }
      getDetailsLists(formattedDate);
    }
  };

  const openAttendanceModal = (e, streakIndex) => {
    e?.stopPropagation?.();
    const streak = dayWiseStreakData[streakIndex];
    if (!streak?.date) {
      return;
    }
    const formattedDate = formatStreakDateForApi(streak.date);
    if (!formattedDate) {
      toastifyMessage({ status: 400, message: "Invalid date format" });
      return;
    }
    setShowAttendanceModal(true);
    getDetailsLists(formattedDate);
  };

  const handleBackClick = () => {
    history.goBack();
  };

  const validateUpiId = (value) => {
    const upiIdPattern = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;

    return upiIdPattern.test(value);
  };

  const handleUpiChange = (e) => {
    const value = e.target.value;
    setState((prevState) => ({ ...prevState, encUpi: value }));
    setUpiError(
      value.trim() && !validateUpiId(value) ? "Invalid UPI ID format" : ""
    );
  };

  const handleAccountHolderNameChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setState((prevState) => ({
        ...prevState,
        encBank: { ...prevState.encBank, acc_name: value },
      }));
    }
  };

  const handleIfscCodeChange = (e) => {
    const value = e.target.value.toUpperCase();
    setState((prevState) => ({
      ...prevState,
      encBank: { ...prevState.encBank, ifsc_code: value },
    }));
  };

  const handleAccountNumberChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setState((prevState) => ({
      ...prevState,
      encBank: { ...prevState.encBank, acc_no: value },
    }));
  };

  const handleConfirmAccountNumberChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setState((prevState) => ({
      ...prevState,
      encBank: { ...prevState.encBank, cacc_no: value },
    }));
  };

  const isSaveButtonDisabled = (type) => {
    if (type === 1) {
      return upiError || !state.encUpi.trim();
    }
    return (
      !state.encBank.acc_name ||
      !state.encBank.ifsc_code ||
      !state.encBank.acc_no ||
      !state.encBank.cacc_no ||
      state.encBank.acc_no !== state.encBank.cacc_no
    );
  };

  const postBankDetails = async (type) => {
    const headers = { Authorization: `Bearer ${token}` };
    const data =
      type === 1
        ? {
          upi_id: state.encUpi,
          type,
          acc_name: "",
          ifsc_code: "",
          acc_no: "",
          cacc_no: "",
        }
        : {
          type,
          acc_name: state.encBank.acc_name,
          ifsc_code: state.encBank.ifsc_code,
          acc_no: state.encBank.acc_no,
          cacc_no: state.encBank.cacc_no,
          upi_id: "",
        };

    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/v1/streak/update/accdata",
        data,
        { headers }
      );
      if (response.data.status === 200) {
        setShowError(false);
        setShowBankDetailsModal(false);
        setShowRedeemConfirmModal(true);
      } else {
        toastifyMessage({
          status: response.data.status,
          message: response.data.message,
        });
      }
    } catch (error) {
      toastifyMessage({
        status: 500,
        message: "Failed to save account details",
      });
    }
  };

  const getTransactionLists = async (type) => {
    const headers = { Authorization: `${tokenType} ${token}` };
    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/v1/streak/redeem",
        { type },
        { headers }
      );
      if (response.data.status === 200) {
        if (paymentDueModal1) {
          setShowPaymentDueModal1(false);
          setShowAdjustmentSuccess(true);
        } else {
          setShowFinalSuccessModal(true);
        }
      } else {
        toastifyMessage({
          status: response.data.status,
          message: response.data.message,
        });
      }
    } catch (error) {
      toastifyMessage({
        status: 500,
        message: "Failed to process transaction",
      });
    }
  };

  const getDetailsLists = async (for_date) => {
    const headers = { Authorization: `${tokenType} ${token}` };
    setLiveClassLoading(true);
    setLiveClassData([]);
    try {
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/v1/getDayStreakPopup/liveClasses?for_date=${for_date}`,
        { headers }
      );
      if (response.data.status === 200) {
        const payload = response.data.data;
        setLiveClassData(Array.isArray(payload) ? payload : []);
      }
    } catch (error) {
      toastifyMessage({
        status: 500,
        message: "Failed to fetch live class data",
      });
    } finally {
      setLiveClassLoading(false);
    }
  };

  const handleWithdrawClick = () => {
    const paymentDueFromApi =
      Number(state.streaksData?.checkDues?.show_pop_up) === 1;

    // Prevent incorrect modal flow if user clicks before checkDues data is ready.
    if (typeof state.streaksData?.checkDues?.show_pop_up === "undefined") {
      return;
    }

    if (paymentDueModal || paymentDueFromApi) {
      setShowPaymentDueModal1(true);
    } else if (state.encBank.acc_no.trim()) {
      // } else if (state.encUpi.trim() || state.encBank.acc_no.trim()) {
      setShowRedeemConfirmModal(true);
    } else {
      // setShowError(true);
      setShowBankDetailsModal(true);
    }
  };

  const handleRedirectToStreak = () => {
    setShowAdjustmentSuccess(false);
  };

  const adjustAmountSuccessfull = () => (
    <div className="adjust-amount-success-container">
      <div
        className="adjust-amount-bck-btn"
        style={{ marginBottom: "10px", marginTop: "1.5rem" }}
      >
        <ArrowLeft
          size={20}
          onClick={handleRedirectToStreak}
          style={{ cursor: "pointer" }}
        />
        <span style={{ marginLeft: "15px" }}>Back</span>
      </div>
      <div className="adjust-amt-img">
        <img src={images.adjustAmtSuccess} alt="success-icon" />
      </div>
      <div className="adjust-amt-title">Streak Redeem Request Sent</div>
      <div className="adjust-amt-description">
        Due Adjustment request has been received successfully and will be
        processed soon.
      </div>
    </div>
  );

  return (
    <>
      <ToastContainer />
      <Header_component />
      {showAdjustmentSuccess ? (
        adjustAmountSuccessfull()
      ) : (
        <div className="streak-container">
          <main className="content">
            <div className="back-button" style={{ marginBottom: "10px" }}>
              <ArrowLeft
                size={20}
                onClick={handleBackClick}
                style={{ cursor: "pointer" }}
              />
              <span style={{ marginLeft: "15px" }}>Streaks</span>
            </div>
            <div className="main-content">
              <div className="main-content-stats">
                <div className="stats">
                  <div className="stats__card stats__card--streaks">
                    <div className="stats__card__icon">
                      <img src={images.fireIcon} alt="fire_icon" />
                    </div>
                    <div className="stats__card__content">
                      <span className="stats__card__content__value">
                        {state.streaksData.total_streak || 0}
                      </span>
                      <span className="stats__card__content__label">
                        Streaks
                      </span>
                    </div>
                  </div>
                  {state?.streaksData?.is_reward_enabled !== 0 && (
                    <div className="stats__card stats__card--earned">
                      <div className="stats__card__icon">
                        <img src={images.moneyIcon} alt="money_icon" />
                      </div>
                      <div className="stats__card__content">
                        <span className="stats__card__content__value">
                          ₹{state.streaksData.money_earned || 0}
                        </span>
                        <span className="stats__card__content__label">
                          Earned
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <section className="streaks">
                <h3 className="streaks__title">Day wise streaks</h3>
                <div className="streaks__timeline">
                  <div className="streaks__days">
                    {state.streaksData.day_wise_streak?.map((streak, index) => {
                      const nextStreak =
                        state.streaksData.day_wise_streak[index + 1];
                      const getLineColor = () =>
                        !nextStreak
                          ? streak.card_color
                          : streak.card_color === "#E23838" &&
                            nextStreak.card_color === "#E23838"
                            ? "#E23838"
                            : streak.card_color === "#C5C5C5" &&
                              nextStreak.card_color === "#C5C5C5"
                              ? "#C5C5C5"
                              : "#E5E7EB";

                      return (
                        <div key={index} className="streaks__day">
                          <div
                            className="streaks__day-circle"
                            style={{
                              backgroundColor: streak.card_color,
                              color: "#FFFFFF",
                              position: "relative",
                            }}
                          >
                            {streak.day}
                            {nextStreak && (
                              <div
                                style={{
                                  position: "absolute",
                                  left: "100%",
                                  top: "50%",
                                  width: "67px",
                                  height: "2px",
                                  backgroundColor: getLineColor(),
                                  transform: "translateY(-50%)",
                                }}
                              />
                            )}
                          </div>
                          <span className="streaks__day-amount">
                            ₹{streak.money}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </section>
              <div className="activity__header">
                <h3 className="activity__header-title mt-4">My Activity</h3>
                <span className="activity__header-subtitle">Till Date</span>
              </div>
              <section className="activity">
                <div className="activity__grid">
                  {state.streaksData.activity?.length > 0 ? (
                    state.streaksData.activity.map((activity, index) => (
                      <div key={index} className="activity__card">
                        <img
                          alt={activity.iconClass}
                          className={`activity__card-icon activity__card-icon--${activity.iconClass}`}
                          src={activity.icon}
                        />
                        <div className="activity__card-content-title">
                          {activity.title}
                        </div>
                        <div className="activity__card-content-value">
                          {activity.count}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="activity__no-data">
                      No activity data available.
                    </div>
                  )}
                </div>
              </section>
              <section>
                <div className="reward_banner">

                  {state?.streaksData?.is_reward_enabled == 0 && (
                    <>
                      <img
                        src={state?.streaksData?.banner}
                        alt="Reward Banner"
                      />
                      <div>
                        {/* Parse and transform the instructions into a ul/li structure */}
                        <div
                          style={{ paddingTop: "20px", paddingBottom: "20px" }}
                          dangerouslySetInnerHTML={{
                            __html: state?.streaksData?.instructions
                              ?.split('<div class="rewards-heading1">')[1]
                              ?.split("</div>")[0],
                          }}
                        />
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "20px",
                            borderRadius: "15px",
                          }}
                        >
                          <div
                            style={{ padding: "15px" }}
                            dangerouslySetInnerHTML={{
                              __html: state?.streaksData?.instructions
                                ?.split('<div class="rewards-heading2">')[1]
                                ?.split("</div>")[0],
                            }}
                          />
                          <ul>
                            {state?.streaksData?.instructions
                              ?.split('<div class="day">')
                              ?.slice(1) // Skip the first split part (before the first <div class="day">)
                              ?.map((day, index) => {
                                const dayText = day?.split("</div>")[0]; // Extract text inside the div
                                return (
                                  <li
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: dayText,
                                    }}
                                  />
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </section>
            </div>
          </main>
          <aside className="sidebar">
            {state?.streaksData?.is_reward_enabled !== 0 && (
              <>
                <div className="sidebar__withdraw">
                  <div>
                    <p className="sidebar__withdraw-amount">
                      ₹{state.streaksData.withdraw_available || 0}
                    </p>
                    <p className="sidebar__withdraw-text">
                      will be able to withdraw
                    </p>
                  </div>
                  <button
                    className="sidebar__withdraw-button"
                    disabled={state.streaksData.withdraw_available <= 0}
                    onClick={handleWithdrawClick}
                  >
                    Withdraw
                  </button>
                </div>
                <p className="sidebar__withdraw-info">
                  <img src={images.user_activity_19} alt="fire_icon" />
                  <span className="sidebar__withdraw-infotxt">
                    The withdraw option will be available once a week after
                    completing the weekly streak.
                  </span>
                </p>
                <button
                  className="sidebar__transactions"
                  onClick={() => history.push("/transcation")}
                >
                  View Transactions
                </button>
              </>
            )}
            <div className="sidebar__activity">
              <div className="sidebar__activity-header">
                <span className="sidebar__activity-daytext">
                  Day wise activity
                </span>
                <DateRangePicker
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  onConfirm={(fromDate, toDate) =>
                    getDayWiseStreak(fromDate, toDate)
                  }
                />
              </div>
              <div
                className="date_sidebar"
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <div className="day-wise-activity">
                  {dayWiseStreakData.length > 0 ? (
                    dayWiseStreakData.map((streak, index) => (
                      <div
                        key={index}
                        className={`day-wise-activity-cards ${openAccordion === index ? "expanded" : ""
                          }`}
                      >
                        <div
                          className="sidebar__activity-day"
                          onClick={() => toggleAccordion(index)}
                        >
                          <div
                            className={`sidebar__activity-day-label ${streak.is_fulfilled
                                ? "sidebar__activity-day-label--active"
                                : "sidebar__activity-day-label--inactive"
                              }`}
                            style={{
                              backgroundColor: streak.card_color,
                              color: "#fff",
                            }}
                          >
                            Day {streak.day}
                          </div>
                          <div className="sidebar__activity-day-date">
                            Date: {streak.date}
                          </div>
                          <img
                            className={`chevron-icon ${openAccordion === index ? "rotate" : ""
                              }`}
                            src={images.down_ar}
                            alt=""
                          />
                        </div>
                        {openAccordion === index && streak.day_activity && (
                          <div className="activity-content__items">
                            <div className="activity-content__headers">
                              <div className="activity-content-heading">
                                Activity:
                              </div>
                              <div className="activity-content-heading">
                                Amount:
                              </div>
                            </div>
                            <div className="activity-content__row">
                              <div className="activity-content__activities">
                                {streak.day_activity.map(
                                  (activity, activityIndex) => (
                                    <div
                                      key={activityIndex}
                                      className="activity-content__item"
                                    >
                                      <img
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                        }}
                                        src={
                                          activity.is_right === null
                                            ? images.streak_day_wise_null
                                            : activity.is_right
                                              ? images.user_activity_59
                                              : images.user_activity_60
                                        }
                                        alt="Activity Status"
                                      />
                                      <span className="activity-content__item-title">
                                        {activity.title}
                                        {activity.title === "Live Class" && (
                                          <img
                                            style={{
                                              marginLeft: "8px",
                                              height: "16px",
                                              width: "16px",
                                              cursor: "pointer",
                                            }}
                                            src={images.user_activity_19}
                                            alt="View live class attendance"
                                            onClick={(e) =>
                                              openAttendanceModal(e, index)
                                            }
                                          />
                                        )}
                                      </span>
                                    </div>
                                  )
                                )}
                              </div>
                              <div className="activity-content__amount">
                                <span className="activity-content__price">
                                  ₹{streak.money}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="no-streaks">No streaks available</p>
                  )}
                </div>
              </div>
            </div>
          </aside>
        </div>
      )}
      <Modal
        show={showError}
        onHide={() => setShowError(false)}
        centered
        className="upi-details-modal"
      >
        <Modal.Header>
          <Modal.Title>Enter UPI Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              postBankDetails(1);
            }}
          >
            <div className="form-group">
              <label htmlFor="upiId">
                UPI ID <span className="required">*</span>
              </label>
              <input
                type="text"
                id="upiId"
                placeholder="Enter UPI ID"
                value={state.encUpi}
                onChange={handleUpiChange}
                className={upiError ? "error-input" : ""}
              />
              {upiError && <p className="error-text">{upiError}</p>}
            </div>
            <p>
              Don't have UPI ID?{" "}
              <button
                type="button"
                className="add-bank-details"
                onClick={() => {
                  setShowError(false);
                  setShowBankDetailsModal(true);
                }}
              >
                Add Bank Details
              </button>
            </p>
            <div className="button-group">
              <Button
                variant="outline-primary"
                type="submit"
                disabled={isSaveButtonDisabled(1)}
              >
                Save & Continue
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showBankDetailsModal}
        onHide={() => setShowBankDetailsModal(false)}
        centered
        className="bankDetailsModal"
      >
        <Modal.Header>
          <Modal.Title>Enter Bank Account Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              postBankDetails(2);
            }}
          >
            <div className="form-group">
              <label htmlFor="accountHolderName">
                Account Holder Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="accountHolderName"
                placeholder="Full Name"
                value={state.encBank.acc_name}
                onChange={handleAccountHolderNameChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="ifscCode">
                IFSC Code <span className="required">*</span>
              </label>
              <input
                type="text"
                id="ifscCode"
                placeholder="ABCD1211336"
                value={state.encBank.ifsc_code}
                onChange={handleIfscCodeChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="accountNumber">
                Account Number <span className="required">*</span>
              </label>
              <input
                type="text"
                id="accountNumber"
                placeholder="0000000000"
                value={state.encBank.acc_no}
                onChange={handleAccountNumberChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmAccountNumber">
                Confirm Account Number <span className="required">*</span>
              </label>
              <input
                type="text"
                id="confirmAccountNumber"
                placeholder="0000000000"
                value={state.encBank.cacc_no}
                onChange={handleConfirmAccountNumberChange}
                required
              />
              {accountNumberError && (
                <p className="error-text">{accountNumberError}</p>
              )}
            </div>
            {/* <p>
              Don't have Bank details?{" "}
              <button
                type="button"
                className="add-bank-details"
                onClick={() => {
                  setShowBankDetailsModal(false);
                  setShowError(true);
                }}
              >
                Add UPI ID
              </button>
            </p> */}
            <div className="button-group">
              <Button
                variant="outline-primary"
                type="submit"
                disabled={isSaveButtonDisabled(2)}
              >
                Save & Continue
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showRedeemConfirmModal}
        onHide={() => setShowRedeemConfirmModal(false)}
        centered
        className="redeem-confirm-modal"
      >
        <Modal.Header>
          <Modal.Title>Verify your details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="confirm-text">
            Please confirm your cash reward redemption details.
          </p>
          <div className="detail-row p-2">
            <span>Coins Value</span>
            <span className="value">
              {withRupeeSymbol(state.streaksData.withdraw_available)}
            </span>
          </div>
          {state.encBank.acc_no ? (
            <>
              <div className="detail-row p-2">
                <span>Account Number</span>
                <span className="value">{state.encBank.acc_no}</span>
              </div>
              <div className="detail-row gray p-2">
                <span>IFSC Code</span>
                <span className="value">{state.encBank.ifsc_code}</span>
              </div>
              <div className="detail-row p-2">
                <span>Name</span>
                <span className="value">{state.encBank.acc_name}</span>
              </div>
            </>
          ) : (
            <div className="detail-row gray p-2">
              <span>UPI ID</span>
              <span className="value">{state.encUpi}</span>
            </div>
          )}
          <div className="button-group">
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowRedeemConfirmModal(false);
                setShowBankDetailsModal(true);
              }}
            >
              Modify
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setShowRedeemConfirmModal(false);
                setShowRedemptionSuccessModal(true);
              }}
            >
              Redeem
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showRedemptionSuccessModal}
        onHide={() => setShowRedemptionSuccessModal(false)}
        centered
        className="redemption-success-modal"
      >
        <Modal.Header>
          <Modal.Title>Your Redemption is Successful!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="confirm-text">
            Please confirm your cash reward redemption details.
          </p>
          <div className="detail-row p-2">
            <span>Coins Value</span>
            <span className="value">
              {withRupeeSymbol(state.streaksData.withdraw_available)}
            </span>
          </div>
          <div className="detail-row gray p-2">
            <span>{state.encBank.acc_no ? "Account Number" : "UPI ID"}</span>
            <span className="value">
              {state.encBank.acc_no || state.encUpi}
            </span>
          </div>
          <div className="button-group">
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowRedemptionSuccessModal(false);
                setShowBankDetailsModal(true);
                // state.encBank.acc_no
                //   ? setShowBankDetailsModal(true)
                //   : setShowError(true);
              }}
            >
              Modify
            </Button>
            <Button
              variant="primary"
              onClick={() => getTransactionLists(state.encBank.acc_no ? 2 : 1)}
            >
              Redeem
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showFinalSuccessModal}
        onHide={() => setShowFinalSuccessModal(false)}
        centered
        className="final-success-modal"
      >
        <Modal.Body className="text-center">
          <div className="success-icon">
            <img src={images.successfulIcon} alt="Success" />
          </div>
          <h2>Your Redemption is Successful!</h2>
          <p>
            Your amount will be credited to your bank account within 48 working
            hours.
          </p>
          <Button onClick={() => setShowFinalSuccessModal(false)}>Ok</Button>
        </Modal.Body>
      </Modal>
      <Modal
        show={showAttendanceModal}
        onHide={() => setShowAttendanceModal(false)}
        centered
        className="attendance-modal"
        dialogClassName="attendance-modal__dialog"
      >
        <button
          type="button"
          className="attendance-modal__close"
          aria-label="Close"
          onClick={() => setShowAttendanceModal(false)}
        >
          ×
        </button>
        <Modal.Body>
          <div className="attendance-info">
            {liveClassLoading ? (
              <p className="attendance-modal__status">Loading class details…</p>
            ) : liveClassData.length > 0 ? (
              liveClassData.map((classData, index) => (
                <div className="attendance-section" key={index}>
                  <div className="attendance-card-header">
                    <div className="attendance-field">
                      <span className="attendance-field__label">Topic:</span>
                      <span className="attendance-field__value">
                        {classData.meeting_topic || "—"}
                      </span>
                    </div>
                    <div className="attendance-field attendance-field--end">
                      <span className="attendance-field__label">
                        Date & Time:
                      </span>
                      <span className="attendance-field__value">
                        {classData.meeting_time || "—"}
                      </span>
                    </div>
                    <hr className="attendance-card-header__divider" />
                    <div className="attendance-field">
                      <span className="attendance-field__label">
                        Total Attended Duration:
                      </span>
                      <span className="attendance-field__value">
                        {classData.final_attended_duration ?? "—"}
                      </span>
                    </div>
                    <div className="attendance-field attendance-field--end">
                      <span className="attendance-field__label">
                        Total Polls Attended:
                      </span>
                      <span className="attendance-field__value">
                        {classData.final_attempted_poll_qns ?? "—"}
                      </span>
                    </div>
                  </div>
                  <table className="attendance-table">
                    <thead>
                      <tr>
                        <th>Session</th>
                        <th>Join Time</th>
                        <th>Leave Time</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      {classData.sessions?.length > 0 ? (
                        classData.sessions.map((session, sessionIndex) => (
                          <tr key={sessionIndex}>
                            <td>Session {sessionIndex + 1}</td>
                            <td>
                              {session.join_time ||
                                session.joinTime ||
                                "—"}
                            </td>
                            <td>
                              {session.leave_time ||
                                session.left_time ||
                                session.leaveTime ||
                                "—"}
                            </td>
                            <td>{session.duration || "—"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          {/* <td colSpan={4} className="attendance-table__empty">
                            No session records
                          </td> */}
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <p className="attendance-modal__status">
                No class data available for this day.
              </p>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <StreakPaymentDueModal
        checkDues={state.streaksData.checkDues}
        setShowPaymentDueModal={setShowPaymentDueModal1}
        paymentDueModal={paymentDueModal1}
        getTransactionLists={getTransactionLists}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.authToken,
  tokenType: state.auth.authType,
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Streak);
